export const manifesto = {
  eyebrow: 'Our belief',
  title: 'A Better View Begins at Home.',
  lead: 'A window is the one part of a house you look through every day. We replace and install windows so the light, the trees and the seasons outside feel like part of the rooms you live in.',
  body: 'Northlight is a residential window company. We survey, supply and install replacement and new-construction windows for homeowners who care about how a room feels at seven in the morning and at dusk in December.',
  image: 'https://public.readdy.ai/ai/img_res/sandbox/52cdcd16a5556f6302fcb5f05fda2c37/d504a9d8-43f0-415a-838b-e8ea414aedab_nl-manifesto.webp',
  imageSmall: 'https://public.readdy.ai/ai/img_res/sandbox/52cdcd16a5556f6302fcb5f05fda2c37/d504a9d8-43f0-415a-838b-e8ea414aedab_nl-manifesto-detail.webp',
};

export const solutions = [
  {
    n: '01',
    title: 'Window Replacement',
    text: 'Retrofit or full-frame replacement of tired, drafty or fogged units, matched to the character of your home.',
    points: ['Full-frame & insert options', 'Historic profile matching', 'Interior trim restored'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/52cdcd16a5556f6302fcb5f05fda2c37/d504a9d8-43f0-415a-838b-e8ea414aedab_nl-sol-replace.webp',
  },
  {
    n: '02',
    title: 'New Installation',
    text: 'New openings, additions and remodels — framed, flashed and sealed for decades of weather.',
    points: ['Structural opening support', 'Flashing & weather barrier', 'Builder coordination'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/52cdcd16a5556f6302fcb5f05fda2c37/d504a9d8-43f0-415a-838b-e8ea414aedab_nl-sol-install.webp',
  },
  {
    n: '03',
    title: 'Energy-Efficient Upgrades',
    text: 'Low-E coated, argon-filled glazing that keeps rooms warmer in winter and calmer in summer.',
    points: ['ENERGY STAR® certified units', 'Double & triple pane', 'Rebate paperwork handled'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/52cdcd16a5556f6302fcb5f05fda2c37/d504a9d8-43f0-415a-838b-e8ea414aedab_nl-sol-energy.webp',
  },
  {
    n: '04',
    title: 'Custom Window Styles',
    text: 'Casement, picture, awning, bay and arched shapes, built to the exact size of each opening.',
    points: ['Wood, fiberglass & clad', 'Custom shapes & grilles', 'Hardware in brass or bronze'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/52cdcd16a5556f6302fcb5f05fda2c37/d504a9d8-43f0-415a-838b-e8ea414aedab_nl-sol-custom.webp',
  },
];

export const lightComfort = {
  eyebrow: 'Natural light & living comfort',
  title: 'Rooms that follow the day.',
  text: 'Well-placed, well-sealed glass changes how a home feels: brighter mornings, quieter evenings, steadier temperatures and a constant, gentle connection to the trees outside.',
  image: 'https://public.readdy.ai/ai/img_res/sandbox/52cdcd16a5556f6302fcb5f05fda2c37/d504a9d8-43f0-415a-838b-e8ea414aedab_nl-light-forest.webp',
  points: [
    { title: 'Daylight', text: 'Larger glass areas and slimmer frames let more light deeper into each room.' },
    { title: 'Thermal comfort', text: 'Insulated glazing reduces cold spots near windows and summer heat gain.' },
    { title: 'Quiet', text: 'Laminated acoustic glass softens traffic and neighborhood noise.' },
  ],
};

export const processSteps = [
  { n: '01', title: 'Consultation', text: 'We visit your home, look at every opening and talk through styles, materials and budget.' },
  { n: '02', title: 'Precise measuring', text: 'Each opening is measured and documented so every window is ordered to the right size.' },
  { n: '03', title: 'Ordering & scheduling', text: 'You approve the final quote; we order your windows and book an installation date.' },
  { n: '04', title: 'Clean installation', text: 'Certified installers remove, fit, seal and finish — and leave the room as they found it.' },
];

export const processImage = 'https://public.readdy.ai/ai/img_res/sandbox/52cdcd16a5556f6302fcb5f05fda2c37/d504a9d8-43f0-415a-838b-e8ea414aedab_nl-process.webp';

export const whyChoose = [
  { title: 'Licensed & insured installers', text: 'Our own trained crews — not subcontractors — handle every installation.' },
  { title: 'Clear, written quotes', text: 'Itemized pricing for product, labor and finishing, with no surprise line items.' },
  { title: 'Respect for your home', text: 'Floor protection, dust control and full clean-up are part of every job.' },
  { title: 'Workmanship warranty', text: 'Installation is backed by our written warranty alongside the manufacturer coverage.' },
];

export const whyImage = 'https://public.readdy.ai/ai/img_res/sandbox/52cdcd16a5556f6302fcb5f05fda2c37/d504a9d8-43f0-415a-838b-e8ea414aedab_nl-why.webp';

export const faqs = [
  { q: 'How long does a window replacement project take?', a: 'Most homes are installed in one to three days once windows arrive. Lead time for ordered windows is typically four to eight weeks depending on style and finish.' },
  { q: 'Do I need to replace all my windows at once?', a: 'No. Many homeowners start with the rooms that matter most and phase the rest. We will help you plan a sequence that keeps styles consistent.' },
  { q: 'Will new windows lower my energy bills?', a: 'Upgrading from single-pane or failing units usually reduces heat loss and drafts. Actual savings depend on your home, climate and current windows.' },
  { q: 'What happens to my interior trim and walls?', a: 'We remove and reinstall or replace trim as needed and seal every joint. Minor touch-ups are included; full repainting can be quoted separately.' },
  { q: 'Is the estimate really free?', a: 'Yes. The consultation and written quote are free with no obligation to proceed.' },
];